export default async function getIsbnInfo(apibase, isbn) {
    if (!isbn) return null;
    const cleanIsbn = isbn.replace(/[-\s]/g, '');
    try {
        const response = await fetch(`${apibase}/proxy/isbndb/${cleanIsbn}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || `Erreur backend: ${response.status}`);
        }
        const data = await response.json();
        return data.book;
    } catch (error) {
        console.error("ISBNdb fetch failed:", error);
        throw error;
    }
}
/*
export default async function getIsbnInfo(apiKey, isbn) {
    if (!isbn) return null;

    // Clean ISBN (remove hyphens and spaces)
    const cleanIsbn = isbn.replace(/[-\s]/g, '');

    try {
        const response = await fetch(`https://api2.isbndb.com/book/${cleanIsbn}`, {
            method: 'GET',
            headers: {
                'Authorization': apiKey,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            if (response.status === 404) {
                throw new Error("Livre non trouvé sur ISBNdb");
            }
            if (response.status === 401 || response.status === 403) {
                throw new Error("Clé API ISBNdb invalide ou expirée");
            }
            throw new Error(`Erreur ISBNdb: ${response.status}`);
        }

        const data = await response.json();
        return data.book;
    } catch (error) {
        console.error("ISBNdb fetch failed:", error);
        throw error;
    }
}*/
